import { useState, useEffect } from 'react';
import api from '../api/axios';
import toast from 'react-hot-toast';
import { MdDelete, MdCheckCircle } from 'react-icons/md';

export default function Moderation() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReports = async () => {
    try {
      const res = await api.get('/admin/comments/reports');
      setReports(res.data.data);
    } catch (err) {
      toast.error('Failed to load reports');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchReports(); }, []);

  const deleteComment = async (commentId) => {
    if (!window.confirm('Delete this comment?')) return;
    try {
      await api.patch(`/admin/comments/${commentId}/delete`);
      toast.success('Comment deleted');
      fetchReports();
    } catch (err) {
      toast.error('Failed');
    }
  };

  const dismissReport = async (reportId) => {
    try {
      await api.patch(`/admin/comments/reports/${reportId}/resolve`);
      toast.success('Report dismissed');
      fetchReports();
    } catch (err) {
      toast.error('Failed');
    }
  };

  if (loading) return <div className="page-loader">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Moderation</h2>
        <span className="badge">{reports.length} pending</span>
      </div>

      {reports.length === 0 ? (
        <div className="empty-state">
          <MdCheckCircle className="empty-icon" />
          <h3>All clear!</h3>
          <p>No reported comments to review.</p>
        </div>
      ) : (
        <div className="moderation-list">
          {reports.map(report => (
            <div key={report.id} className="card moderation-card">
              <div className="mod-header">
                <span className="badge badge-danger">Reported</span>
                {report.Comment?.Article && (
                  <span className="mod-article">on: {report.Comment.Article.title}</span>
                )}
              </div>
              <div className="mod-body">
                <p className="mod-comment">"{report.Comment?.body}"</p>
                {report.reason && <p className="mod-reason">Reason: {report.reason}</p>}
                <p className="mod-date">{new Date(report.created_at).toLocaleDateString()}</p>
              </div>
              <div className="mod-actions">
                <button className="btn btn-sm btn-danger" onClick={() => deleteComment(report.Comment?.id)}>
                  <MdDelete /> Delete Comment
                </button>
                <button className="btn btn-sm btn-ghost" onClick={() => dismissReport(report.id)}>
                  <MdCheckCircle /> Dismiss
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
